export default __webpack_public_path__ + "locales/bg/UploadPanel.json?hash=7d4f52e033826b898395750d54570002";